import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  linkedSignal,
  model,
} from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'

import { Store } from '@ngrx/store'

import { FlxTabBarModule, FlxTabComponent } from '@flowx/angular-ui-toolkit'
import { PanelSize } from '@flowx/designer/modules/process-details/process-details-helper.service'
import { ExpandablePanelComponent } from '@flowx/designer/shared/components/bottom-panel/expandable-panel/expandable-panel.component'
import { InstanceWorkflowsComponent } from '@flowx/designer/shared/components/instance-workflows/instance-workflows.component'
import { ProcessInstance } from '@flowx/designer/shared/entities/process-instance.types'
import { UiFlowSession } from '@flowx/designer/shared/entities/ui-flow-sessions.types'
import { selectQueryParam } from '@flowx/designer/shared/store/selectors/router.selectors'

import { UiFlowSessionAuditLogsComponent } from '../ui-flow-session-audit-logs/ui-flow-session-audit-logs.component'
import { UiFlowSessionDetailsPanelHeaderComponent } from '../ui-flow-session-details-panel-header/ui-flow-session-details-panel-header.component'
import { UiFlowSessionProcessesComponent } from '../ui-flow-session-processes/ui-flow-session-processes.component'
import { UiFlowSessionVariablesComponent } from '../ui-flow-session-variables/ui-flow-session-variables.component'

export enum TabHeaders {
  AUDIT = 'Audit Log',
  PROCESSES = 'Processes',
  VARIABLES = 'Variables',
  WORKFLOWS = 'Workflows',
}

@Component({
  selector: 'flx-ui-flow-session-details-panel',
  imports: [
    ExpandablePanelComponent,
    FlxTabBarModule,
    UiFlowSessionAuditLogsComponent,
    UiFlowSessionDetailsPanelHeaderComponent,
    UiFlowSessionProcessesComponent,
    UiFlowSessionVariablesComponent,
    InstanceWorkflowsComponent,
  ],
  templateUrl: './ui-flow-session-details-panel.component.html',
  styleUrl: './ui-flow-session-details-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiFlowSessionDetailsPanelComponent {
  #store = inject(Store)
  #router = inject(Router)
  #route = inject(ActivatedRoute)

  size = model<PanelSize>(PanelSize.MEDIUM)
  uiFlowSession = input.required<UiFlowSession>()
  processInstances = input.required<ProcessInstance[]>()
  showToggleButtons = input(true)

  tabs = [
    { id: 'variables', index: 0, header: TabHeaders.VARIABLES, visible: true },
    { id: 'audit', index: 1, header: TabHeaders.AUDIT, visible: true },
    { id: 'processes', index: 2, header: TabHeaders.PROCESSES, visible: true },
    { id: 'workflows', index: 3, header: TabHeaders.WORKFLOWS, visible: true },
  ]
  selectedTabIndex = linkedSignal(
    () =>
      this.tabs.find((tab) => tab.id === this.#store.selectSignal(selectQueryParam('tab'))())
        ?.index ?? 0
  )

  readonly TabHeaders = TabHeaders

  onTabChange(tab: FlxTabComponent): void {
    const tabQueryParam = this.tabs.find((item) => item.header === tab.label())?.id
    this.#router.navigate([], {
      relativeTo: this.#route,
      queryParams: {
        tab: tabQueryParam,
      },
      queryParamsHandling: 'merge',
    })
  }
}
